import { render, staticRenderFns } from "./ModuleConfigureInfo.vue?vue&type=template&id=3edb74c8&"
import script from "./ModuleConfigureInfo.vue?vue&type=script&lang=js&"
export * from "./ModuleConfigureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports